import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import SentryErrorBoundary from '@/components/error/SentryErrorBoundary'
import { initSentry } from '@/config/sentry'

// Initialize Sentry
initSentry();

// Render the app with Sentry Error Boundary
ReactDOM.createRoot(document.getElementById('root')).render(
  <SentryErrorBoundary>
    <App />
  </SentryErrorBoundary>
) 